import {
  AOPMaltaAdmissionData,
  AOPMaltaAdmissionFRData,
  AOPMaltaAdmissionDEData,
  AOPMaltaInvoiceData,
  AOPMaltaInvoiceFRData,
  AOPMaltaInvoiceDEData,
  AOPMaltaAcknowledgementData,
  AOPMaltaPaymentConfirmationData,
  AOPMaltaStudentData,
  AOPMaltaCertificateData,
  ///////////////////////
  AOPPolandAdmissionData,
  AOPPolandInvoiceData,
  AOPPolandPaymentConfirmationData,
  AOPPolandAcknowledgementData,
  ///////////////////////
  AOPUkraineAdmissionData,
  AOPUkraineInvoiceData,
  AOPUkrainePaymentConfirmationData,
  AOPUkraineAcknowledgementData,
  AOPUkraineRequestData,
  AOPUkraineInquiryData,
  AOPSwitzerlandAdmissionData,
  AOPSwitzerlandInvoiceData,
  AOPSwitzerlandStudentData,
  AOPSwitzerlandDegreeDocumentsData,
  AOPShengenAdmissionData,
  DocumentsQRCodeData,
  DocumentsEmailData,
} from "../types/admissionOffice";
import { apiType } from "./apiType";
import { pushNotificationBus } from "@/src/components/CustomUtils/PushNotifications/PushNotificationsProvider";
import {
  resolveIsFeuComUaOffice,
  resolveOfficeUrlForDocCreate,
  resolveTaskIdForDocCreate,
  resolveUserIdForDocCreate,
  withAdmissionDocCreateFields,
} from "@/src/utils/admissionOffice/resolveOfficeUrlForDocCreate";
import {
  listSwitzerlandStudentLetterSignatures,
  type SwitzerlandStudentLetterTemplateName,
} from "@/src/constants/AdmissionOffice/Switzerland/AOSwitzerlandEnConsts";

interface CreateTranscriptResponse {
  message: string;
  seria: string;
  pdf_path: string;
}

const notifyDocSuccess = (message = "Document created successfully.") => {
  pushNotificationBus.emit({ title: "Document created", message, type: "success" });
};

const notifyDocError = (message = "Failed to create document.") => {
  pushNotificationBus.emit({ title: "Document error", message, type: "error" });
};

const postAdmissionDoc = async <T = unknown>(path: string, data: unknown, errorLabel: string, successMessage?: string) => {
  try {
    const payload =
      data != null && typeof data === "object" ? withAdmissionDocCreateFields(data as object) : {};
    console.log("[qarshisu.net] create document payload:", { path, data: payload });
    const response = await apiType.admissionDB.post<T>(path, payload);
    notifyDocSuccess(successMessage);
    return response;
  } catch (error) {
    console.log(errorLabel, error);
    notifyDocError();
    return null;
  }
};

export const admissionOfficeRequests = {
  //------Malta------//
  createAdmissionDoc: async (data: AOPMaltaAdmissionData, signature: string) => {
    return await postAdmissionDoc(`/admission?template_name=${signature}`, data, "Это ошибка createAdmissionDoc:");
  },
  createAdmissionDocFrench: async (data: AOPMaltaAdmissionFRData, signature: string) => {
    return await postAdmissionDoc(`/fr/admission?template_name=${signature}`, data, "Это ошибка createAdmissionDocFrench:");
  },
  createAdmissionDocGerman: async (data: AOPMaltaAdmissionDEData, signature: string) => {
    return await postAdmissionDoc(`/de/admission?template_name=${signature}`, data, "Это ошибка createAdmissionDocGerman:");
  },
  createAdmissionDocUzb: async (data: AOPMaltaAdmissionData, signature: string) => {
    return await postAdmissionDoc(`/uzb/admission?template_name=${signature}`, data, "Это ошибка createAdmissionDocUzb:");
  },
  createAdmissionInvoiceDoc: async (data: AOPMaltaAdmissionData) => {
    return await postAdmissionDoc(`/admission-invoice`, data, "Это ошибка createAdmissionInvoiceDoc:");
  },
  createAdmissionInvoiceDocFrench: async (data: AOPMaltaAdmissionFRData) => {
    return await postAdmissionDoc(`/fr/admission-invoice`, data, "Это ошибка createAdmissionInvoiceDocFrench:");
  },
  createAdmissionInvoiceDocGerman: async (data: AOPMaltaAdmissionDEData) => {
    return await postAdmissionDoc(`/de/admission-invoice`, data, "Это ошибка createAdmissionInvoiceDocGerman:");
  },
  createAdmissionInvoiceDocUzb: async (data: AOPMaltaAdmissionData) => {
    return await postAdmissionDoc(`/uzb/admission-invoice`, data, "Это ошибка createAdmissionInvoiceDocUzb:");
  },
  createInvoiceDoc: async (data: AOPMaltaInvoiceData) => {
    return await postAdmissionDoc(`/invoice`, data, "Это ошибка createAdmissionInvoiceDoc:");
  },
  createInvoiceDocFrench: async (data: AOPMaltaInvoiceFRData) => {
    return await postAdmissionDoc(`/fr/invoice`, data, "Это ошибка createInvoiceDocFrench:");
  },
  createInvoiceDocGerman: async (data: AOPMaltaInvoiceDEData) => {
    return await postAdmissionDoc(`/de/invoice`, data, "Это ошибка createInvoiceDocGerman:");
  },
  createInvoiceDocUzb: async (data: AOPMaltaInvoiceData) => {
    return await postAdmissionDoc(`/uzb/invoice`, data, "Это ошибка createInvoiceDocUzb:");
  },
  createAcknowledgementDoc: async (data: AOPMaltaAcknowledgementData) => {
    return await postAdmissionDoc(`/acknowledgement`, data, "Это ошибка createAdmissionInvoiceDoc:");
  },
  createPaymentConfirmationDoc: async (data: AOPMaltaPaymentConfirmationData) => {
    return await postAdmissionDoc(`/payment`, data, "Это ошибка createAdmissionInvoiceDoc:");
  },
  createStudentDoc: async (data: AOPMaltaStudentData) => {
    const officeUrl = resolveOfficeUrlForDocCreate((data as { office_url?: string }).office_url);
    const taskId = resolveTaskIdForDocCreate((data as { task_id?: string }).task_id);
    const userId = resolveUserIdForDocCreate(data as { user_id?: string; student_id?: string; applicant_id?: string });
    console.log("[qarshisu.net] create document payload:", {
      path: "/student-letter",
      data: {
        ...data,
        ...(officeUrl ? { office_url: officeUrl } : {}),
        ...(taskId ? { task_id: taskId } : {}),
        user_id: userId,
      },
    });
    try {
      const formData = new FormData();

      formData.append("currentDate", data.currentDate);
      formData.append("fullName", data.fullName);
      formData.append("dateOfBirth", data.dateOfBirth);
      formData.append("nationality", data.nationality);
      formData.append("course", data.course);
      formData.append("userOffice", data.userOffice);
      formData.append("whose_doc", data.whose_doc);
      formData.append("title", data.title);
      formData.append("duration", data.duration);
      formData.append("mediumOfInstruction", data.mediumOfInstruction);
      formData.append("passportNumber", data.passportNumber);
      formData.append("academicYear", data.academicYear);
      formData.append("yearOfStudy", data.yearOfStudy);
      formData.append("yearStudyMode", data.yearStudyMode);
      formData.append("coursePrefix", data.coursePrefix);
      formData.append("bodyStudentLetter", JSON.stringify(data.bodyStudentLetter));
      formData.append("secondBodyStudentLetter", JSON.stringify(data.secondBodyStudentLetter));
      formData.append("secondPageDate", data.secondPageDate);
      formData.append("thirdBodyStudentLetter", JSON.stringify(data.thirdBodyStudentLetter));
      formData.append("user_id", userId);
      if (officeUrl) {
        formData.append("office_url", officeUrl);
      }
      if (taskId) {
        formData.append("task_id", taskId);
      }

      if (data.file) {
        formData.append("file", data.file);
      }

      const response = await apiType.admissionDB.post("/student-letter", formData);
      console.log("SUCCESS RESPONSE:", response);
      notifyDocSuccess();

      return response;
    } catch (error: any) {
      console.log("Это ошибка createStudentDoc:", error);
      notifyDocError();
      return null;
    }
  },
  createCertificateDoc: async (data: AOPMaltaCertificateData) => {
    try {
      const payload = withAdmissionDocCreateFields(data);
      console.log("[qarshisu.net] create document payload:", { path: "/certificate", data: payload });
      const response = await apiType.admissionDB.post(`/certificate`, payload);
      console.log("SUCCESS RESPONSE:", response);
      notifyDocSuccess();
      return response;
    } catch (error) {
      console.log("Это ошибка createAdmissionCertificateDoc:", error);
      notifyDocError();
      return null;
    }
  },
  createAuthorizationLetterteDoc: async (data: AOPMaltaCertificateData) => {
    try {
      const payload = withAdmissionDocCreateFields(data);
      console.log("[qarshisu.net] create document payload:", { path: "/authorization-letter", data: payload });
      const response = await apiType.admissionDB.post(`/authorization-letter`, payload);
      console.log("SUCCESS RESPONSE:", response);
      notifyDocSuccess();
      return response;
    } catch (error) {
      console.log("Это ошибка createAdmissionCertificateDoc:", error);
      notifyDocError();
      return null;
    }
  },
  //------Poland------//
  createPolandAdmissionDoc: async (data: AOPPolandAdmissionData, signature: string) => {
    return await postAdmissionDoc(`/pl/admission?template_name=${signature}`, data, "Это ошибка createPolandAdmissionDoc:");
  },
  createPolandAdmissionInvoiceDoc: async (data: AOPPolandAdmissionData) => {
    return await postAdmissionDoc(`/pl/admission-invoice`, data, "Это ошибка createPolandAdmissionInvoiceDoc:");
  },
  createPolandInvoiceDoc: async (data: AOPPolandInvoiceData) => {
    return await postAdmissionDoc(`/pl/invoice`, data, "Это ошибка createPolandInvoiceDoc:");
  },
  createPolandPaymentConfirmationDoc: async (data: AOPPolandPaymentConfirmationData) => {
    return await postAdmissionDoc(`/pl/payment`, data, "Это ошибка createPolandPaymentConfirmationDoc:");
  },
  createPolandAcknowledgementDoc: async (data: AOPPolandAcknowledgementData) => {
    return await postAdmissionDoc(`/pl/acknowledgement`, data, "Это ошибка createPolandAcknowledgementDoc:");
  },
  //------Ukraine------//
  createUkraineAdmissionDoc: async (data: AOPUkraineAdmissionData, signature: string) => {
    const isFeuUa = resolveIsFeuComUaOffice((data as { office_url?: string | null }).office_url);
    const path = isFeuUa ? `/feu/admission` : `/ua/admission?template_name=${signature}`;
    return await postAdmissionDoc(path, data, "Это ошибка createUkraineAdmissionDoc:");
  },
  createUkraineAdmissionInvoiceDoc: async (data: AOPUkraineAdmissionData) => {
    return await postAdmissionDoc(`/ua/admission-invoice`, data, "Это ошибка createUkraineAdmissionInvoiceDoc:");
  },
  createUkraineInvoiceDoc: async (data: AOPUkraineInvoiceData) => {
    return await postAdmissionDoc(`/ua/invoice`, data, "Это ошибка createUkraineInvoiceDoc:");
  },
  createUkrainePaymentConfirmationDoc: async (data: AOPUkrainePaymentConfirmationData) => {
    return await postAdmissionDoc(`/ua/payment`, data, "Это ошибка createUkrainePaymentConfirmationDoc:");
  },
  createUkraineAcknowledgementDoc: async (data: AOPUkraineAcknowledgementData) => {
    return await postAdmissionDoc(`/ua/acknowledgement`, data, "Это ошибка createUkraineAcknowledgementDoc:");
  },
  createUkraineRequestDoc: async (data: AOPUkraineRequestData) => {
    return await postAdmissionDoc(`/ua/pv`, data, "Это ошибка createUkraineRequestDoc:");
  },
  createUkraineInquiryDoc: async (data: AOPUkraineInquiryData) => {
    return await postAdmissionDoc(`/ua/certificate-ls`, data, "Это ошибка createUkraineInquiryDoc:");
  },
  //------Shengen (qarshisu.net)------//
  createShengenAdmissionDoc: async (data: AOPShengenAdmissionData) => {
    return await postAdmissionDoc(`/shengen/admission`, data, "Это ошибка createShengenAdmissionDoc:");
  },
  //------Switzerland (uni2.qarshisu.net)------//
  createSwitzerlandAdmissionDoc: async (data: AOPSwitzerlandAdmissionData, online = false) => {
    try {
      const path = `/admission?online=${online}`;
      console.log("[uni2.qarshisu.net] create document payload:", { path, data });
      const response = await apiType.switzerlandAdmissionDB.post(path, data);
      notifyDocSuccess();
      return response;
    } catch (error) {
      console.log("Это ошибка createSwitzerlandAdmissionDoc:", error);
      notifyDocError();
      return null;
    }
  },
  createSwitzerlandInvoiceDoc: async (data: AOPSwitzerlandInvoiceData) => {
    try {
      const { yearOfStudy: _yearOfStudy, yearStudyMode: _yearStudyMode, ...payload } = data;
      console.log("[uni2.qarshisu.net] create document payload:", { path: "/invoice", data: payload });
      const response = await apiType.switzerlandAdmissionDB.post("/invoice", payload);
      notifyDocSuccess();
      return response;
    } catch (error) {
      console.log("Это ошибка createSwitzerlandInvoiceDoc:", error);
      notifyDocError();
      return null;
    }
  },
  createSwitzerlandStudentDoc: async (data: AOPSwitzerlandStudentData) => {
    const signatureLabel = data.signature?.trim() || "";
    const templateName: SwitzerlandStudentLetterTemplateName =
      listSwitzerlandStudentLetterSignatures[signatureLabel] ?? "NEW";
    const path = `/student-letter?template_name=${templateName}`;
    try {
      const formData = new FormData();
      formData.append("currentDate", data.currentDate);
      formData.append("fullName", data.fullName);
      formData.append("dateOfBirth", data.dateOfBirth);
      formData.append("nationality", data.nationality);
      formData.append("course", data.course);
      formData.append("userOffice", data.userOffice);
      formData.append("whose_doc", data.whose_doc);
      if (data.title != null) formData.append("title", data.title);
      if (data.passportNumber != null) formData.append("passportNumber", data.passportNumber);
      if (data.academicYear != null) formData.append("academicYear", data.academicYear);
      if (data.duration != null) formData.append("duration", data.duration);
      if (data.mediumOfInstruction != null) formData.append("mediumOfInstruction", data.mediumOfInstruction);
      if (data.yearOfStudy != null) formData.append("yearOfStudy", data.yearOfStudy);
      if (data.yearStudyMode != null) formData.append("yearStudyMode", data.yearStudyMode);
      if (data.coursePrefix != null) formData.append("coursePrefix", data.coursePrefix);
      formData.append("bodyStudentLetter", JSON.stringify(data.bodyStudentLetter));
      if (data.file) {
        formData.append("file", data.file);
      }

      console.log("[uni2.qarshisu.net] create document payload:", {
        path,
        data: { ...data, file: data.file ? `[File:${data.file.name}]` : null, template_name: templateName },
      });
      const response = await apiType.switzerlandAdmissionDB.post(path, formData);
      notifyDocSuccess();
      return response;
    } catch (error) {
      console.log("Это ошибка createSwitzerlandStudentDoc:", error);
      notifyDocError();
      return null;
    }
  },
  createSwitzerlandDegreeDoc: async (data: AOPSwitzerlandDegreeDocumentsData) => {
    try {
      const formData = new FormData();
      if (data.file) {
        formData.append("file", data.file);
      }

      console.log("[uni2.qarshisu.net] create document payload:", {
        path: "/transcript-with-seria",
        data: {
          fullname: data.fullname,
          whose_doc: data.whose_doc,
          userOffice: data.userOffice,
          date: data.date,
          document_seria: data.document_seria,
          file: data.file ? `[File:${data.file.name}]` : null,
        },
      });

      const response = await apiType.switzerlandAdmissionDB.post("/transcript-with-seria", formData, {
        params: {
          fullname: data.fullname,
          whose_doc: data.whose_doc,
          userOffice: data.userOffice,
          date: data.date,
          document_seria: data.document_seria,
        },
      });
      notifyDocSuccess();
      return response;
    } catch (error) {
      console.log("Это ошибка createSwitzerlandDegreeDoc:", error);
      notifyDocError();
      return null;
    }
  },
  //------Documents QR Code------//
  createDocumentsQRCode: async (data: DocumentsQRCodeData): Promise<CreateTranscriptResponse> => {
    const officeUrl = resolveOfficeUrlForDocCreate((data as { office_url?: string }).office_url);
    console.log("[qarshisu.net] create document payload:", {
      path: "/transcript",
      data: officeUrl ? { ...data, office_url: officeUrl } : data,
    });
    const formData = new FormData();

    if (data.file) {
      formData.append("file", data.file);
    }

    const response = await apiType.admissionDB.post<CreateTranscriptResponse>("/transcript", formData, {
      params: {
        fullname: data.fullname,
        whose_doc: data.whose_doc,
        userOffice: data.userOffice,
        date: data.date,
        type: data.type,
        ...(officeUrl ? { office_url: officeUrl } : {}),
      },
    });

    return response;
  },
  //------Documents Email------//
  createDocumentsEmailDoc: async (data: DocumentsEmailData) => {
    return await postAdmissionDoc(`/send-doc`, data, "Это ошибка createUkraineRequestDoc:");
  },
};
